"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwoColumn = exports.twoColumnGridVariants = exports.twoColumnTextColorVariants = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.twoColumnTextColorVariants = {
    light: 'text-gray-e',
    dark: 'text-gray',
};
exports.twoColumnGridVariants = {
    large: ['md:w-1/2', 'md:w-1/2'],
    medium: ['md:w-1/3', 'md:w-2/3'],
    small: ['w-full sm:w-1/3 md:w-1/6', 'w-full sm:w-2/3 md:w-5/6'],
};
function TwoColumn(_a) {
    var { className, customId, backgroundImage, backgroundFixed, backgroundColor, textColor = 'dark', reverseColumns = false, columnSize = 'large', style, children, heading } = _a, props = __rest(_a, ["className", "customId", "backgroundImage", "backgroundFixed", "backgroundColor", "textColor", "reverseColumns", "columnSize", "style", "children", "heading"]);
    const childrenArr = react_1.default.useMemo(() => [...react_1.default.Children.toArray(children)], [children]);
    const columnElements = react_1.default.useMemo(() => {
        const childrenElements = childrenArr.map((child, ind) => (react_1.default.createElement("div", { key: ind, className: (0, classnames_1.default)(exports.twoColumnGridVariants[columnSize][ind], `w-full px-4 md:py-4 ${reverseColumns
                ? ind === 0
                    ? columnSize === 'small'
                        ? 'sm:order-2'
                        : 'md:order-2'
                    : 'order-1'
                : 'order-1'}`) }, child)));
        return childrenElements;
    }, [columnSize, childrenArr, reverseColumns]);
    return (react_1.default.createElement("div", { id: customId, style: Object.assign({ backgroundImage: backgroundImage && `url(${backgroundImage})`, backgroundColor }, style), className: (0, classnames_1.default)('w-full', { 'bg-fixed': backgroundFixed }, { 'bg-cover bg-no-repeat': backgroundImage }) },
        react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('w-full max-w-[1440px] mx-auto flex flex-wrap py-8', exports.twoColumnTextColorVariants[textColor], 'two-column', textColor, className) }, props),
            heading,
            columnElements)));
}
exports.TwoColumn = TwoColumn;
